import CrudModule from "@/components/CrudModule";
import { rupees } from "@/lib/api";
import { ShieldCheck } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export default function Insurance() {
    return (
        <CrudModule
            testid="insurance-page"
            eyebrow="Insurance Tracker"
            title="Coverage you can count on."
            subtitle="Premium reminders, nominee tracking, and gap alerts — without the spreadsheets."
            endpoint="/insurance"
            emptyIcon={ShieldCheck}
            emptyTitle="No policies yet"
            emptyBody="Add LIC, term, health, vehicle and property policies. Set the next premium date so we can remind you."
            fields={[
                { key: "policy_type", label: "Policy type", type: "select", required: true, defaultValue: "life",
                  options: [
                    { value: "life", label: "Life / Term" },
                    { value: "health", label: "Health" },
                    { value: "vehicle", label: "Vehicle" },
                    { value: "property", label: "Property" },
                  ] },
                { key: "provider", label: "Provider", required: true, placeholder: "LIC, HDFC Ergo…" },
                { key: "policy_number", label: "Policy number", required: true },
                { key: "sum_assured", label: "Sum assured (₹)", type: "number" },
                { key: "premium_amount", label: "Premium amount (₹)", type: "number" },
                { key: "premium_frequency", label: "Premium frequency", type: "select", defaultValue: "yearly",
                  options: [
                    { value: "monthly", label: "Monthly" },
                    { value: "quarterly", label: "Quarterly" },
                    { value: "half_yearly", label: "Half-yearly" },
                    { value: "yearly", label: "Yearly" },
                  ] },
                { key: "premium_due_date", label: "Next premium due", type: "date" },
                { key: "nominee_name", label: "Nominee name" },
                { key: "nominee_relation", label: "Nominee relation" },
                { key: "notes", label: "Notes", type: "textarea" },
            ]}
            columns={[
                { key: "policy_type", label: "Type",
                  render: (r) => <Badge variant="outline" className="capitalize">{r.policy_type}</Badge> },
                { key: "provider", label: "Provider" },
                { key: "policy_number", label: "Policy #",
                  render: (r) => <span className="font-mono text-xs">{r.policy_number}</span> },
                { key: "sum_assured", label: "Sum assured", render: (r) => <span className="font-mono">{rupees(r.sum_assured)}</span> },
                { key: "premium_amount", label: "Premium", render: (r) => <span className="font-mono">{rupees(r.premium_amount)}</span> },
                { key: "premium_due_date", label: "Next due", render: (r) => r.premium_due_date || "—" },
                { key: "nominee_name", label: "Nominee",
                  render: (r) => r.nominee_name ? r.nominee_name : <span className="text-destructive font-semibold">Missing</span> },
            ]}
        />
    );
}
